<!--
 * @Author: zhengxiaoxiao
 * @Date: 2020-08-12 15:55:43
 * @Description: 
-->
<template>
	<div class="info">
		<template v-for="(item,index) in dataList">
			<div :class="{'info-cell':true,'info-color':index%2 ===0}">
				<div class="info-wrap">
					<template v-if="index%2 ===0">

						<div class="info-content" :class="[item.index%2 === 0 ? 'right-position' : 'left-position']">
							<h2 class="title">{{item.title}}{{dataList.index}}</h2>
							<h4 class="content" :class="lang == 'en' ? 'content-en' : 'content-zh'" v-html="item.content"></h4>
						</div>
					</template>
					<img :src="item.pic" alt />
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: 'item',
	props: {
		dataList: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
	computed: {
		lang() {
			return sessionStorage.getItem('language')
		},
	},
}
</script>

<style lang='less' scoped>
@import "../../../style/constant.less";

.info {
	margin: 0 auto;

	.info-cell {
		width: 100%;
		padding: 100px 0;
		background-color: #ffffff;
		.info-color {
			background-color: #fafafa;
		}
		.info-wrap {
			position: relative;
			max-width: @page-width;
			margin: 0 auto;
			img {
				width: 100%;
			}
			.left-position {
				left: -3%;
			}
			.right-position {
				right: -3%;
			}
			.info-content {
				position: absolute;
				top: 10%;
				padding: 35px 80px;
				background: #fbfbfb;
				height: 370px;
				// min-width: 660px;

				.title {
					margin-bottom: 15px;
				}
				@media screen and (min-width: 320px) and (max-width: 480px) {
					.title {
						font-size: 26px;
						position: relative;
						&::before {
							position: absolute;
							content: " ";
							width: 4px;
							height: 100%;
							background: #2a69ef;
							left: -16px;
						}
					}
				}
				.content-zh {
					letter-spacing: 1.4px;
					line-height: 30px;
					text-align: justify;
				}
				.content-en {
					line-height: 19px;
					text-align: left;
				}
				.content {
					white-space: pre-line;
				}
			}
			@media screen and (min-width: 320px) and (max-width: 480px) {
				.info-content {
					position: inherit;
					height: auto;
					padding: 20px;
				}
			}
		}
		@media screen and (min-width: 320px) and (max-width: 480px) {
			.info-wrap {
				position: inherit;
				display: flex;
				justify-content: center;
				flex-direction: column;
				margin: 24px;
			}
		}
	}
	@media screen and (min-width: 320px) and (max-width: 480px) {
		.info-cell {
			padding: 0px;
		}
	}
}
</style>